import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.admin.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-component-admin-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.admin.home/view.scss */
/* src/app/component.admin.home/view.scss: no such file or directory */`],
})
export class ComponentAdminHomeComponent implements OnInit {
    public machineCount: number | null = null;
    public totalQuantity: number | null = null;
    public totalWeight: number | null = null;
    public totalPlate: number | null = null;

    public gradeLog: any[] = [];
    public productChart: any = null;

    public eggprice: any = null;

    private gradeMap = '왕란,특란,대란,중란,소란,경란,파란,혈란,오란,등외'.split(',');

    constructor(@Inject( Service)         public service: Service,@Inject( Title    )         private title: Title    ) { }

    async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow(true, "/auth/login");
        if (!allowed) return;
        this.title.setTitle('에그텍스마트플랫폼 관리자 페이지');
        await this.load();
    }

    private async load() {
        const [statisticRes, eggPriceRes] = await Promise.all([
            wiz.call('statistic'),
            wiz.call('eggprice')
        ]);

        this.applyStatistic(statisticRes);
        this.applyEggPrice(eggPriceRes);

        await this.service.render();
    }

    private applyStatistic(response: any) {
        const { code, data } = response || {};
        if (code !== 200) return;

        this.machineCount = data.machines ?? 0;
        this.gradeLog = data.log ?? [];

        let quantity = 0;
        let weight = 0;
        let plate = 0;
        for (const item of this.gradeLog) {
            quantity += Number(item?.quantity ?? 0);
            weight += Number(item?.weight ?? 0);
            plate += Number(item?.plate ?? 0);
        }

        this.totalQuantity = quantity;
        this.totalWeight = weight;
        this.totalPlate = plate;

        // 생산 현황을 선 그래프 형식으로 변환
        const labels: string[] = [];
        const values: number[] = [];
        const colors = ['#f69232', '#8b5cf6', '#38bdf8', '#10b981', '#ec4899', '#eab308', '#14b8a6', '#ef4444', '#6366f1', '#9ca3af'];

        for (const item of this.gradeLog) {
            const grade = item.grade ? this.gradeMap[(item.grade - 1)] || `등급${item.grade}` : '';
            labels.push(grade);
            values.push(item.quantity || 0);
        }

        if (labels.length > 0) {
            this.productChart = {
                title: '등급별 생산수량',
                labels,
                datasets: [{
                    label: '생산수량',
                    data: values,
                    fill: true,
                    backgroundColor: 'rgba(246,146,50,0.1)',
                    borderColor: '#f69232',
                    tension: 0.3,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    pointBackgroundColor: '#f69232'
                }]
            };
        }
    }

    private applyEggPrice(chartres: any) {
        if (!chartres || chartres.code !== 200) return;

        const datasets = [
            {
                label: '왕란',
                data: [],
                fill: false,
                borderColor: '#f69232',
                tension: 0.3,
                pointRadius: 0
            },
            {
                label: '특란',
                data: [],
                fill: false,
                borderColor: '#8b5cf6',
                tension: 0.3,
                pointRadius: 0
            },
            {
                label: '대란',
                data: [],
                fill: false,
                borderColor: '#38bdf8',
                tension: 0.3,
                pointRadius: 0
            },
            {
                label: '중란',
                data: [],
                fill: false,
                borderColor: '#10b981',
                tension: 0.3,
                pointRadius: 0
            }
        ];

        const labels: string[] = [];

        chartres.data.forEach((item: any) => {
            const d = item.date;
            labels.push(typeof d === 'string' ? d.substring(0, 10) : String(d));
            datasets[0].data.push(item.egg1 ?? null);
            datasets[1].data.push(item.egg2 ?? null);
            datasets[2].data.push(item.egg3 ?? null);
            datasets[3].data.push(item.egg4 ?? null);
        });

        this.eggprice = {
            title: '계란시세 (원/30개)',
            link: '/admin/monitoring/eggprice',
            labels,
            datasets
        };
    }
}

export default ComponentAdminHomeComponent;